import { useMemo } from 'react';
import getPriceByPlan from '../utils/getPriceByPlan';

type UseGetTotalsProps = {
  beneficiaryAllPlans: any[];
  unitsPrice: number;
  simulatedRetentionPercent: number;
  includeBeneficiaryNotVestedUnits: boolean;
};

export const useGetTotals = ({
  beneficiaryAllPlans,
  unitsPrice,
  simulatedRetentionPercent,
  includeBeneficiaryNotVestedUnits,
}: UseGetTotalsProps) => {
  const simulatedTotal = useMemo(
    () =>
      beneficiaryAllPlans.reduce((acc, beneficiaryData) => {
        const resultPrice = getPriceByPlan(
          beneficiaryData,
          unitsPrice,
          includeBeneficiaryNotVestedUnits
        );

        return acc + resultPrice;
      }, 0),
    [beneficiaryAllPlans, unitsPrice, includeBeneficiaryNotVestedUnits]
  );

  const retentionTotal = useMemo(
    () => simulatedTotal * (simulatedRetentionPercent / 100),
    [simulatedTotal, simulatedRetentionPercent]
  );

  return {
    data: { simulatedTotal, retentionTotal },
    isLoading: false,
    isError: false,
    actions: {},
  };
};
